var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-mml-xybox h-scroll",attrs:{"resp":_vm.resp}},[_vm._v("\n  "+_vm._s(_vm.resp.errorMsg)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }